<template>
  <el-dialog
    :visible="visible"
    width="30%"
    @close="cancel"
    destroy-on-close
    :title="openType === 'add' ? '新增品牌' : '编辑品牌'"
    custom-class="customModal">
    <AppForm
      v-if="visible"
      ref="form"
      formStyle="default"
      :fields="formFields"
      :rules="rules"
      :defaultValues="defaultValues"
      @cancel="cancel"
      @submit="submit"
      />
  </el-dialog>
</template>

<script>
import { ManufacturerService } from '../../service/manufacturer.service';
  export default {
    name: 'formManufacturer',
    data() {
      return {
        visible: false,
        openType: '',
        rules: {
          name: [{ required: true, message: '请选择品牌图标'}],
        },
        formFields: [
          { type: 'input', key: 'name', label: '厂商名', span: 24 },
        ],
        defaultValues: {

        },
      }
    },
    methods: {
      open(type, data) {
        this.openType = type;
        if(type === 'edit') {
          this.defaultValues = Object.assign({}, data);
        } else {
          this.defaultValues = {};
        }
        this.visible = true;
      },
      cancel() {
        this.visible = false;
      },
      async submit(data) {
        await ManufacturerService.save(data)
        this.cancel();
        this.$emit('success');
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>